import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import come_be_part from "../assets/come_be_part.webp";
import "./Transaction.css";

const Transition = () => {
  return (
    <section className="part-body-1 transition-section">
      <div className="part-body-2">
        <div className="py-0" style={{ backgroundColor: "#fff2d8" }}>
          <div className="p-0">
            <div className="row align-items-center">
              <div className="col-md-6 ">
                <div className="contains">
                  <h4 className="fw-semibold mt-4 mt-md-5 fs-5 fs-md-4">
                    Come, be part of this transition to{" "}
                    <br className="d-none d-md-block" />
                    India's evolving financial life
                  </h4>
                  <p
                    className="text-muted"
                    style={{ maxWidth: "500px", fontSize: "16px" }}
                  >
                    Our goal is to provide easy-to-use, transparent financial
                    products that cater to the rapidly evolving financial needs
                    of India.
                  </p>
                  <div className="row">
                    <div className="col-6">
                      <ul
                        className="list-unstyled fw-semibold "
                      >
                        <li>• Real-time Transactions</li>
                        <li>• Partner Network</li>
                      </ul>
                    </div>
                    <div className="col-6 ">
                      <ul
                        className="list-unstyled fw-semibold"
                      >
                        <li>• Robust Security</li>
                        <li>• Latest Technology</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 p-0">
                <img
                  src={come_be_part}
                  alt="Meeting"
                  className="image-card-custom w-100 h-100 object-fit-cover m-0"
                  style={{ borderRadius: "0" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Transition;
